import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'
import { formatDuration } from '@/utils/time'

interface Props {
  component: ComponentProgressDetailView
  index?: number
}

export function MetaStrip({ component, index }: Props) {
  const { t } = useTranslation('coaching')
  const items: string[] = []

  if (index != null) items.push(t('meta.step', { n: index }))
  if (component.elapsedSeconds && component.elapsedSeconds > 0) {
    items.push(t('meta.elapsed', { duration: formatDuration(component.elapsedSeconds) }))
  }
  if (component.type === 'quiz' && component.quiz) {
    if (component.quiz.attemptCount > 0) {
      items.push(t('meta.attempts', { count: component.quiz.attemptCount }))
    }
    items.push(t('meta.correctRate', { rate: component.quiz.correctRate }))
  }
  if (component.type === 'video' && component.video) {
    items.push(t('meta.watchPercent', { percent: component.video.watchPercent }))
  }

  if (items.length === 0) return null
  return (
    <div className="text-xs text-gray-500">
      {items.join(' · ')}
    </div>
  )
}
